module.exports = __webpack_public_path__ + "static/media/b2_p16_clickable.933d700d.png";